var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"maintenance-stripe text-center\">\n<span translate><strong>Oral.fi on väliaikaisesti huoltotilassa.</strong> Kaikki sivuston toiminnot eivät ole käytettävissä. Pahoittelemme mahdollista haittaa.</span>\n<span ng-if=\"$ctrl.endTime\" translate translate-comment=\"{{endTime}} on huoltotilan päättymisaika, esim. 'huomenna klo 15.00'.\" translate-params-end-time=\"$ctrl.endTime.calendar()\">\nHuollon arvioitu päättymisaika on <span class=\"maintenance-stripe-end-time\">{{ endTime }}</span>.\n</span>\n</div>\n";
var id1="app/common/keepalive/maintenance-stripe.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/keepalive/maintenance-stripe.tpl.html
// module id = 426
// module chunks = 4